import { GraphQLClient } from "graphql-request";
import { setting } from "./setting";

const url = setting.gqlApiHost + "/graphql";
const options = {
  method: "post"
};
export default new GraphQLClient(url, options);
